<template>
  <b-modal
    id="youtube-insert-modal"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="youtubeInsertModal"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Insira um vídeo do YouTube
    </template>

    <template v-slot:default>
      <div class="default-form text-center position-relative col-md-10 mx-auto">
        <div class="form-group default-input">
          <input type="text" class="form-control with-label" v-model.trim="src" placeholder="" />
          <label>ID do vídeo</label>
        </div>
        <p class="font-size-xSmall">
          <strong>Dica:</strong> O ID do vídeo é a sequência de números no final da URL do vídeo no YouTube, como a parte grifada no exemplo a seguir: https://www.youtube.com/watch?v=<strong>wVgIt47LLMI</strong> ou https://youtu.be/<strong>wVgIt47LLMI</strong>
        </p>
        <Button
          class="btn btn-outline-color2 btn-sm mt-2"
          :disabled="!src"
          @click="submit"
        >
          Inserir
        </Button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import { getYoutubeSrcIDFromLink } from '@/utils'
import { mapState } from 'vuex'

export default {
  name: 'YoutubeModal',
  data () {
    return {
      src: ''
    }
  },
  computed: {
    modalClasses () {
      return {
        'default-modal': true
      }
    }
  },
  methods: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    submit () {
      const src = getYoutubeSrcIDFromLink(this.src)
      this.$emit('confirmed', src)
      this.$bvModal.hide('youtube-insert-modal')
    },
    shown () {},
    hidden () {
      this.src = ''
    }
  }
}
</script>
